import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CustomerGraph from "../../features/dashboard/customerGraph";
import IssuesGraph from "../../features/dashboard/issuesGraph";
import MaintenanceTeamGraph from "../../features/dashboard/maintenanceTeamGraph";
// import EarningGraph from "../../features/dashboard/earningGraph";
import useTranslation from "../../hooks/traslation";
// import { GRAPH_TYPE } from "../../utils/enums";
import { useLazyGetDashboardQuery } from "../../services/dashboard";

import { showError } from "../../constants/toasts";
import EarningGraph from "../../features/dashboard/earningGraph";

export interface dashBoardData {
  employer: number;
  freelancer: number;
  activeTasks: number;
  completedTasks: number;
  totalEarnings: number;
}

const initialDashboardData: dashBoardData = {
  employer: 0,
  freelancer: 0,
  activeTasks: 0,
  completedTasks: 0,
  totalEarnings: 0,
};

const Dashboard = () => {
  const navigate = useNavigate();
  const translate = useTranslation();

  const [getDashboard] = useLazyGetDashboardQuery();

  const [graphData, setGraphData] =
    useState<dashBoardData>(initialDashboardData);

  //dashboard Data
  const getGraphData = async () => {
    try {
      const response = await getDashboard().unwrap();
      if (response?.statusCode === 200) {
        setGraphData(response?.data || initialDashboardData);
      } else {
        setGraphData(initialDashboardData);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getGraphData();
  }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>{translate?.dashboard?.dashboard}</h1>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/manage-employers")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="" />
          </figure>
          <h2>{graphData?.employer}</h2>
          <p>{translate.main.totalEmployer}</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-freelancer")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="" />
          </figure>
          <h2>{graphData?.freelancer}</h2>
          <p>{translate.main.totalFreelancer}</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-tasks")}>
          <figure>
            <img src="/static/images/support_icon.svg" alt="" />
          </figure>
          <h2>{graphData?.activeTasks}</h2>
          <p>{translate.main.activeTask}</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-tasks")}>
          <figure>
            <img src="/static/images/support_icon.svg" alt="" />
          </figure>
          <h2>{graphData?.completedTasks}</h2>
          <p>{translate.main.closedTask}</p>
        </div>

        <div className="cards" onClick={() => navigate("/manage-payments")}>
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>{graphData?.totalEarnings}</h2>
          <p>{translate.main.totalEarning}</p>
        </div>
      </div>
      <div className="grid_sc gap_m">
        <CustomerGraph />
        <IssuesGraph />
        <MaintenanceTeamGraph />
        <EarningGraph />
      </div>
    </MainContainer>
  );
};

export default Dashboard;
